// extracted by mini-css-extract-plugin
export var animationContainer = "_mx-0";
export var footer = "_mx-1";
export var gray = "_mx-2";
export var lineItem = "_mx-3";
export var lineItemImage = "_mx-4";
export var lineItemInfo = "_mx-5";
export var lineItemText = "_mx-6";
export var lineItems = "_mx-7";
export var modalContent = "_mx-8";
export var options = "_mx-9";
export var orderName = "_mx-a";
export var refundAmount = "_mx-b";